import React, { useLayoutEffect } from 'react'

import ReportCard from '../components/ReportCard/ReportCard'
import { validRule, RULES } from '../../../constants/Entitlements'
import { PortalLayout } from '../components'
import farmerReportTypes from '../../../util/farmerReportTypes'

import './Styles.css'

const ReportListing = ({ history }) => {
  const reports = farmerReportTypes.toArray()

  const handleOnClickReport = (report) => {
    history.push({
      pathname: '/farmers/farm-information',
      state: { report }
    })
  }

  useLayoutEffect(() => {
    const hasAccess = validRule(RULES.FARMER_PORTAL)
    if (!hasAccess) {
      return history.push('/farmers/portal')
    }
  }, [])

  return (
    <PortalLayout>
      <div className="report-listing">
        <p className="subtitle show-desktop">
          Escolha um relatório e fique informado de tudo que acontece ao seu redor
        </p>
        <p className="subtitle show-mobile">Escolha um relatório</p>
        <div className="wrapper">
          {reports.map((report) => (
            <ReportCard key={report.type} report={report} onClick={handleOnClickReport} />
          ))}
        </div>
      </div>
    </PortalLayout>
  )
}

export default ReportListing
